import React, { useEffect, useRef, useState } from "react";
import "./AssignmentControl.css";

/**
 * AssignmentControl
 * Dropdown that lets an agent/admin (re)assign a conversation to a
 * specific team member.
 *
 * Props:
 *  - agents: [{ id, name, status: "online" | "away" | "offline" }]
 *  - assignedAgentId
 *  - onAssign(agentId)
 */
export default function AssignmentControl({
  agents = [],
  assignedAgentId = null,
  onAssign = () => {},
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const assignedAgent = agents.find((a) => a.id === assignedAgentId);

  const initials = (name) =>
    name
      .split(" ")
      .map((p) => p[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();

  return (
    <div className="cb-assignment-control" ref={ref}>
      <button className="cb-assign-trigger" onClick={() => setOpen((o) => !o)}>
        {assignedAgent ? `Assigned: ${assignedAgent.name}` : "Assign agent"} ▾
      </button>

      {open && (
        <div className="cb-assign-menu">
          <div className="cb-assign-menu-title">Assign to</div>
          {agents.map((a) => (
            <button
              key={a.id}
              className={`cb-assign-option ${
                a.id === assignedAgentId ? "selected" : ""
              }`}
              onClick={() => {
                onAssign(a.id);
                setOpen(false);
              }}
            >
              <span className="cb-assign-avatar">{initials(a.name)}</span>
              {a.name}
              <span className={`cb-status-dot ${a.status}`} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
